module.exports = __webpack_public_path__ + "img/2-2.c0600a98.png";